<template>
  <div class="oct-salon-setting-form">
    <form>
      <oct-form>
        <oct-form-group
          label="LINE連携用予約URL"
        >
          <!-- Reservation URL -->
          <oct-text-field
            type="url"
            v-model="$_octSSF_reservationUrl"
          >
            <template #helperTextInvalid>
              LINE連携用予約URLが正しくありません。
            </template>
          </oct-text-field>
        </oct-form-group>
      </oct-form>
    </form>
  </div>
</template>

<script>
import OctTextField from '@/components/text-field/OctTextField.vue'
import OctForm from '@/components/form/OctForm.vue'
import OctFormGroup from '@/components/form/OctFormGroup.vue'

export default {
  name: 'OctSalonSettingForm',
  components: {
    OctTextField,
    OctForm,
    OctFormGroup,
  },
  props: {
    /** Reservation URL */
    reservationUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    /** Reservation URL for form binding */
    $_octSSF_reservationUrl: {
      get () {
        return this.reservationUrl
      },
      set (val) {
        this.$emit('update:reservationUrl', val)
      }
    }
  },
  methods: {
    /** Validate the form */
    validate () {
      if (!this.$el || !this.$el.querySelector('form')) return false
      return this.$el.querySelector('form').reportValidity()
    }
  }
}
</script>